/** WorkOS-only: redirect the client to this URL to sign out (clears session and redirects). */
export const WORKOS_LOGOUT_PATH = "/api/auth/logout"

/**
 * URL search param that opens the auth lightbox (`sign-in` | `sign-up`).
 * Used with `returnPathname` for post-auth redirect (see AuthLightboxProvider).
 */
export const AUTH_MODAL_QUERY_PARAM = "auth" as const

/**
 * When `"true"`, sign-in/sign-up pages show email + password fields (requires Email+Password enabled in WorkOS).
 */
export function isEmailPasswordAuthEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_EMAIL_PASSWORD_AUTH === "true"
}

